import classNames from 'classnames'
import PropTypes from 'prop-types'
import Image from 'components/image'
import Link from 'components/link'
import { registryHomePath } from 'lib/urls'
import { bookmarksBarTitle } from './browser-specific-instructions'
import DraggableBookmarkButton from './draggable-bookmark-button'
import InstallInstructionsByBrowser from './install-instructions-by-browser'
import InstallExtensionButton from './install-extension-button'
import InstallExtensionInstructions from './install-extension-instructions'
import QuoteSymbol from 'shared/svg/quote-symbol.svg'
import css from './add-babylist-button.scss'
// Used for /add-items page

const AddBabylistButton = ({ bookmarkletJS, showExtensionInstall }) => (
  <>
    {showExtensionInstall ? (
      <InstallExtension />
    ) : (
      <InstallBookmarkmark bookmarkletJS={bookmarkletJS} />
    )}
  </>
)

AddBabylistButton.propTypes = {
  bookmarkletJS: PropTypes.string.isRequired,
  showExtensionInstall: PropTypes.bool.isRequired,
}

const InstallBookmarkmark = ({ bookmarkletJS, browser }) => {
  return (
    <>
      <div className="h3 bold mbl text-center">
        The Babylist button lets you add items to your registry from any store!
      </div>
      <p className="text-center">
        {`Drag the button below to your ${bookmarksBarTitle()} bar to get started.`}
      </p>
      <DraggableBookmarkButton bookmarkletJS={bookmarkletJS} />
      <hr className="mvxl" />
      <InstallInstructionsByBrowser browser={browser} />
    </>
  )
}

const InstallExtension = () => {
  return (
    <>
      <div className={css.titleText}>
        Real quick! Install the Babylist Button to add items to your registry
      </div>
      <div className={css.infoText}>
        Our Chrome extension lets you add items to your registry from any
        website.
      </div>
      <div className="text-center">
        <InstallExtensionButton
          className={classNames(
            'btn-shadow animated bounce delay-4500ms',
            css.installExtensionButton
          )}
          showChromeLogo={false}
          buttonText="Add to Chrome"
        />
      </div>
      <InstallExtensionInstructions className={css.mainImage} />
      <div className={css.testimonial}>
        <div className={css.quoteSymbolContainer}>
          <QuoteSymbol className={css.quoteSymbol} />
        </div>
        <p>
          "I love the Babylist Button and being able to add virtually anything
          to our registry. It's so helpful and makes our registry more
          well-rounded and more 'us.'"
        </p>
      </div>
    </>
  )
}

export default AddBabylistButton
